/* @flow weak */
import PropTypes from 'prop-types';

import _ from 'lodash';

const LayerPropTypes = {
  placement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  alignment: (props, propName, componentName) => {
    const alignment = props.alignment;
    if (alignment !== 'middle') {
      const placement = props.placement;
      if (_.includes(['top', 'bottom'], placement) && !_.includes(['left', 'right'], alignment)) {
        return new Error(
          `Invalid prop \`${propName}\` of value \`${alignment}\` supplied to ` +
            `\`${componentName}\`, expected one of ["left", "right"] when \`placement\` is ` +
            `\`${placement}\`.`
        );
      }
      if (_.includes(['left', 'right'], placement) && !_.includes(['top', 'bottom'], alignment)) {
        return new Error(
          `Invalid prop \`${propName}\` of value \`${alignment}\` supplied to ` +
            `\`${componentName}\`, expected one of ["top", "bottom"] when \`placement\` is ` +
            `\`${placement}\`.`
        );
      }
    }
    return undefined;
  },
};

export default LayerPropTypes;
